import React from 'react'
import { strippedInputObj } from '../Interfaces/TestCaseInterface';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import './PageList.css'
import { InfoTooltip } from './InfoTooltip';

interface TestBookendsProps {
  testCaseStart: strippedInputObj,
  testCaseComplete: strippedInputObj,
  setTestCaseStart: React.Dispatch<React.SetStateAction<strippedInputObj>>,
  setTestCaseComplete: React.Dispatch<React.SetStateAction<strippedInputObj>>,
  inputError: boolean,
  editable: boolean
}

export const TestBookends = (props: TestBookendsProps) => {

  return (
    <Stack className="pageList">
      <Typography variant='h5'>
        Test Definition
      </Typography>
      <List className='mb-2'>
        <ListItem>
          <Typography variant='h6'>Test Case Start<InfoTooltip position='top' helpText='Information used by Test Runner to start the tests.' /></Typography>
          {
            props.testCaseStart.value === "" && props.inputError ?
              <div className='alert'>You must enter a start URL</div> : <></>
          }
        </ListItem>
        <ListItem>
          <TextField
            required
            fullWidth
            label='URL for B2C start page'
            name="testCaseStartURL"
            disabled={!props.editable}
            value={props.testCaseStart.value}
            onChange={e => props.setTestCaseStart({ ...props.testCaseStart, value: e.target.value })}
          />
        </ListItem>
        <ListItem>
          <TextField
            fullWidth
            label='ID for HTML element on page'
            name="testCaseStartItem"
            disabled={!props.editable}
            value={props.testCaseStart.id}
            onChange={e => props.setTestCaseStart({ ...props.testCaseStart, id: e.target.value })}
          />
        </ListItem>
      </List>
      <List>
        <ListItem>
          <Typography variant='h6'>Test Case Complete<InfoTooltip position='top' helpText='Information used by Test Runner to complete the tests.' /></Typography>
          {
            props.testCaseComplete.value === "" && props.inputError ?
              <div className='alert'>You must enter an end URL</div> : <></>
          }
        </ListItem>
        <ListItem>
          <TextField
            required
            fullWidth
            label='URL for test completion page'
            name="testCaseCompleteURL"
            disabled={!props.editable}
            value={props.testCaseComplete.value}
            placeholder={'ex. https://jwt.ms'}
            onChange={e => props.setTestCaseComplete({ ...props.testCaseComplete, value: e.target.value })}
          />
        </ListItem>
        <ListItem>
          <TextField
            fullWidth
            label='ID for element on success page'
            name="testCaseCompleteItem"
            disabled={!props.editable}
            value={props.testCaseComplete.id}
            onChange={e => props.setTestCaseComplete({ ...props.testCaseComplete, id: e.target.value })}
          />
        </ListItem>
      </List>
    </Stack>
  )
} // PageList() render fn
